var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"canvas-container"},[_c('Canvas-3d',{attrs:{"defaultFrontModel":_vm.$route.params.model,"defaultTemplesColor":_vm.$route.params.tcolor,"defaultFrontColor":_vm.$route.params.fcolor,"defaultSunLenses":_vm.$route.params.lenses,"shouldLoadScene":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }